import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { HashRouter } from 'react-router-dom'
import { store } from './redux/store';
import './styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>
);
